import { RangeControl, Button, Dashicon } from '@wordpress/components';
import { useState, useEffect, useRef } from '@wordpress/element';
import './style.scss';

const CustomRangeControl = ({ label, value, onChange, min, max, step }) => {
	const initialValue = useRef(value);
	const [isModified, setIsModified] = useState(false);

	useEffect(() => {
		setIsModified(value !== initialValue.current);
	}, [value]);

	return (
		<div className="bwd-custom-range-control">
			<RangeControl
				label={label}
				value={value}
				onChange={(newValue) => {
					onChange(newValue);
					setIsModified(newValue !== initialValue.current);
				}}
				min={min}
				max={max}
				step={step}
				trackColor="#00ced1"
                showTooltip={false}
			/>
			{isModified && (
				<Button
					icon={<Dashicon icon="image-rotate" />}
					onClick={() => {
						onChange(initialValue.current);
						setIsModified(false);
					}}
					className="custom-range-control-reset"
				/>
			)}
		</div>
	);
};


export default CustomRangeControl;